import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { pickBy } from "lodash";
import { Observable } from "rxjs";
import {
  Vaccine,
  VaccineCreate,
  VaccineUpdate
} from "src/app/backend/models/vaccine";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class VaccineBackend {
  private readonly http = inject(HttpClient);

  @UserNotify({
    successMessage: marker("Vaccino creato"),
    errorMessage: marker("Impossibile creare il vaccino")
  })
  create(vaccine: Partial<VaccineCreate>): Observable<Vaccine> {
    return this.http.post<Vaccine>(
      `${environment.snoots.api.healthcare}/vaccines`,
      vaccine
    );
  }

  load(id: string): Observable<Vaccine> {
    return this.http.get<Vaccine>(
      `${environment.snoots.api.healthcare}/vaccines/${id}`
    );
  }

  search(request: PageRequest): Observable<PaginatedResult<Vaccine>> {
    return this.http.get<PaginatedResult<Vaccine>>(
      `${environment.snoots.api.healthcare}/vaccines`,
      {
        params: pickBy({
          p: request.page,
          s: request.pageSize
        })
      }
    );
  }

  searchBySpecies(
    request: PageRequest,
    species: string
  ): Observable<PaginatedResult<Vaccine>> {
    return this.http.get<PaginatedResult<Vaccine>>(
      `${environment.snoots.api.healthcare}/vaccines`,
      {
        params: pickBy({
          p: request.page,
          s: request.pageSize,
          species
        })
      }
    );
  }

  searchAllBySpecies(species: string): Observable<PaginatedResult<Vaccine>> {
    return this.http.get<PaginatedResult<Vaccine>>(
      `${environment.snoots.api.healthcare}/vaccines`,
      {
        params: pickBy({
          p: 1,
          s: 10000,
          species
        })
      }
    );
  }

  @UserNotify({
    successMessage: marker("Vaccino aggiornato"),
    errorMessage: marker("Impossibile aggiornare il vaccino")
  })
  update(id: string, payload: Partial<VaccineUpdate>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.healthcare}/vaccines/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Vaccino rimosso"),
    errorMessage: marker("Impossibile rimuovere il vaccino")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/vaccines/${id}`
    );
  }
}
